module.exports = __webpack_public_path__ + "img/teacherResource-5.0da7b5cf.png";